"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TurnStartedEventArgs = void 0;
const EventType_1 = require("../EventType");
class TurnStartedEventArgs {
    constructor() {
        this.__type = EventType_1.EventType.TurnStarted;
        this.__typeName = "TurnStarted";
    }
}
exports.TurnStartedEventArgs = TurnStartedEventArgs;
